// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-space1-u5myb {
	margin-bottom: 6px !important;
}

.Login-space2-DmJSa {
	margin-bottom: 12px !important;
}

.Login-space3-jxA4j {
	margin-bottom: 18px !important;
}

.Login-space4-KiayF {
	margin-bottom: 24px !important;
}

.Login-space5-fO8hs {
	margin-bottom: 30px !important;
}

.Login-space6-QkXcF {
	margin-bottom: 36px !important;
}

.Login-space7-KXnk1 {
	margin-bottom: 42px !important;
}

.Login-space8-g4fd4 {
	margin-bottom: 48px !important;
}

.Login-spaceTop1-w5NGW {
	margin-top: 6px !important;
}

.Login-spaceTop2-GhA5g {
	margin-top: 12px !important;
}

.Login-spaceTop3-atxq_ {
	margin-top: 18px !important;
}

.Login-spaceTop4-UOLYG {
	margin-top: 24px !important;
}

.Login-spaceTop5-HzsB3 {
	margin-top: 30px !important;
}

.Login-spaceTop6-Lm294 {
	margin-top: 36px !important;
}

.Login-spaceTop7-QoOBN {
	margin-top: 42px !important;
}

.Login-spaceTop8-ljCM0 {
	margin-top: 48px !important;
}

.Login-noMargin-OpKwx {
	margin: 0px !important;
}

.Login-padding1-y7N4g {
	padding-bottom: 6px !important;
}

.Login-padding2-0SnDt {
	padding-bottom: 12px !important;
}

.Login-padding3-v9Dmu {
	padding-bottom: 18px !important;
}

.Login-padding4-Vj0IS {
	padding-bottom: 24px !important;
}

.Login-padding5-h6e8j {
	padding-bottom: 30px !important;
}

.Login-padding6-pAZjN {
	padding-bottom: 36px !important;
}

.Login-padding7-yf_0d {
	padding-bottom: 42px !important;
}

.Login-paddingTop1-G88uY {
	padding-top: 6px !important;
}

.Login-paddingTop2-t65XQ {
	padding-top: 12px !important;
}

.Login-paddingTop3-F0Dfc {
	padding-top: 18px !important;
}

.Login-paddingTop4-bj3QR {
	padding-top: 24px !important;
}

.Login-paddingTop5-Oxy2C {
	padding-top: 30px !important;
}

.Login-paddingTop6-XZE4u {
	padding-top: 36px !important;
}

.Login-paddingTop7-ZM4_B {
	padding-top: 42px !important;
}

.Login-noPadding-Jz1YD {
	padding: 0px !important;
}

.Login-spaceMarginBottom0-HgZUW {
	margin-bottom: 0;
}

.Login-textBold-H1Fjp {
	font-weight: 500 !important;
}

.Login-textBolder-jNMNa {
	font-weight: 700 !important;
}

.Login-textNormal-dCl8b {
	font-weight: normal !important;
}

/*New Design Text Colors */

.Login-textDarkBlue-Gg7UR {
	color: rgb(20, 39, 94) !important;
}

.Login-textLightBlue-pFVzE {
	color: rgb(57, 87, 106) !important;
}

.Login-textLightSandleGreen-snJnq {
	color: rgb(76, 86, 41) !important;
}

.Login-textLightBrown-WSjMy {
	color: rgb(115, 79, 33) !important;
}

.Login-textMediumMaroon-RenPL {
	color: rgb(87, 37, 51) !important;
}

.Login-textBrown-otnuz {
	color: rgb(160, 47, 24) !important;
}

.Login-textMaroon-ov9SJ {
	color: rgb(155, 49, 67) !important;
}

.Login-textDarkBrown-mzW7Z {
	color: rgb(83, 18, 16) !important;
}

.Login-textMediumBrown-VXLQl {
	color: rgb(142, 28, 10) !important;
}

.Login-textSkyBlue-yckq8 {
	color: rgb(37, 117, 141) !important;
}

.Login-textGray-BbgzW {
	color: rgb(77, 65, 51) !important;
}

.Login-root-NZFXR {
	padding-left: 20px;
	padding-right: 20px;
}

.Login-container-R_KwO {
	margin: 40px auto;
	padding: 20px;
	max-width: 380px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/login/Login.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1LA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,gBAAgB;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 40px auto;\n\tpadding: 20px;\n\tmax-width: 380px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Login-space1-u5myb`,
	"space2": `Login-space2-DmJSa`,
	"space3": `Login-space3-jxA4j`,
	"space4": `Login-space4-KiayF`,
	"space5": `Login-space5-fO8hs`,
	"space6": `Login-space6-QkXcF`,
	"space7": `Login-space7-KXnk1`,
	"space8": `Login-space8-g4fd4`,
	"spaceTop1": `Login-spaceTop1-w5NGW`,
	"spaceTop2": `Login-spaceTop2-GhA5g`,
	"spaceTop3": `Login-spaceTop3-atxq_`,
	"spaceTop4": `Login-spaceTop4-UOLYG`,
	"spaceTop5": `Login-spaceTop5-HzsB3`,
	"spaceTop6": `Login-spaceTop6-Lm294`,
	"spaceTop7": `Login-spaceTop7-QoOBN`,
	"spaceTop8": `Login-spaceTop8-ljCM0`,
	"noMargin": `Login-noMargin-OpKwx`,
	"padding1": `Login-padding1-y7N4g`,
	"padding2": `Login-padding2-0SnDt`,
	"padding3": `Login-padding3-v9Dmu`,
	"padding4": `Login-padding4-Vj0IS`,
	"padding5": `Login-padding5-h6e8j`,
	"padding6": `Login-padding6-pAZjN`,
	"padding7": `Login-padding7-yf_0d`,
	"paddingTop1": `Login-paddingTop1-G88uY`,
	"paddingTop2": `Login-paddingTop2-t65XQ`,
	"paddingTop3": `Login-paddingTop3-F0Dfc`,
	"paddingTop4": `Login-paddingTop4-bj3QR`,
	"paddingTop5": `Login-paddingTop5-Oxy2C`,
	"paddingTop6": `Login-paddingTop6-XZE4u`,
	"paddingTop7": `Login-paddingTop7-ZM4_B`,
	"noPadding": `Login-noPadding-Jz1YD`,
	"spaceMarginBottom0": `Login-spaceMarginBottom0-HgZUW`,
	"textBold": `Login-textBold-H1Fjp`,
	"textBolder": `Login-textBolder-jNMNa`,
	"textNormal": `Login-textNormal-dCl8b`,
	"textDarkBlue": `Login-textDarkBlue-Gg7UR`,
	"textLightBlue": `Login-textLightBlue-pFVzE`,
	"textLightSandleGreen": `Login-textLightSandleGreen-snJnq`,
	"textLightBrown": `Login-textLightBrown-WSjMy`,
	"textMediumMaroon": `Login-textMediumMaroon-RenPL`,
	"textBrown": `Login-textBrown-otnuz`,
	"textMaroon": `Login-textMaroon-ov9SJ`,
	"textDarkBrown": `Login-textDarkBrown-mzW7Z`,
	"textMediumBrown": `Login-textMediumBrown-VXLQl`,
	"textSkyBlue": `Login-textSkyBlue-yckq8`,
	"textGray": `Login-textGray-BbgzW`,
	"root": `Login-root-NZFXR`,
	"container": `Login-container-R_KwO`
};
module.exports = ___CSS_LOADER_EXPORT___;
